import styled from 'styled-components';

export const RefundLabel = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 4px;
`;

export const HereLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
